/**
 * Converts stored rich-text HTML into plain text for previews and search.
 * Uses the browser's DOMParser (does not execute scripts or load images).
 * Block elements become spaces so words from different paragraphs don't merge.
 */
export function htmlToPlainText(html: string | null | undefined): string {
  if (!html) return ''
  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('br, p, li, h1, h2, h3, h4, h5, h6, blockquote, pre, hr').forEach((el) => {
    el.append(' ')
  })
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim()
}
